import React from 'react'
import tooltip from '../../../assets/images/icono_info_white.png'

const ImgTooltipInfo = () => {
  return (
    <img height={"15px"} width={"16px"} style={{ marginBottom: "2px" }} src={tooltip} />
  )
};

export default ImgTooltipInfo;